// hooks/useCourseDays.js
import { useEffect, useState } from "react";

const useCourseDays = (registrationId) => {
  const [days, setDays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!registrationId) return;
    fetch(`https://www.denisbitter.de/stage01/api/get_course_days.php?registration_id=${registrationId}`)
      .then(res => res.json())
        .then(data => {
            if (data.success && Array.isArray(data.days)) {
                setDays(data.days);
            } else {
                setDays([]); // Fallback!
                setError(data.error || "Fehler beim Laden");
            }
            })
      .catch(err => {
        setError("Serverfehler");
      })
      .finally(() => setLoading(false));
  }, [registrationId]);

  return { days, loading, error };
};

export default useCourseDays;
